import { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { SmartNotificationRepeatTypes } from '../../enums';
import { SmartNotificationModel } from '../../models/SmartNotifications';

interface ISmartNotificationService {
  getSmartNotifications: (
    productId: number | null,
    categoryId: number | null,
    isForHome: boolean,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<SmartNotificationModel[]>>;
}

export const smartNotificationService: ISmartNotificationService = {
  async getSmartNotifications(productId, categoryId, isForHome, axiosConfig) {
    const response = await ajax.post<SmartNotificationModel[]>(
      `${config.benefitApiUrl}/smart-notifications`,
      { productId, categoryId, isForHome },
      axiosConfig,
    );

    if (response.hasErrors) return response;

    const filteredData = response.data.filter(e => {
      const { id, repeatType, days } = e;
      const storageKey = `smartNotification.${id}`;

      if (repeatType === SmartNotificationRepeatTypes.Session) {
        const timestamp = sessionStorage.getItem(storageKey);
        if (!timestamp) {
          sessionStorage.setItem(storageKey, new Date().toString());
          return true;
        } else {
          return false;
        }
      }

      if (repeatType === SmartNotificationRepeatTypes.OnceEveryNDays) {
        const timestamp = localStorage.getItem(storageKey);

        if (!timestamp) {
          localStorage.setItem(storageKey, new Date().toString());
          return true;
        }

        if (moment(new Date()) > moment(new Date(timestamp)).add({ days })) {
          localStorage.setItem(storageKey, new Date().toString());
          return true;
        }

        return false;
      }

      return true;
    });

    return { ...response, data: filteredData };
  },
};
